<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/1/1e/Default-avatar.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>\
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Conta</strong></b-dropdown-header>
      <b-dropdown-item v-on:click="meuPerfil"><i class="fa fa-user" /> Meu Perfil</b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item v-on:click="logout"><i class="fa fa-lock" /> Sair</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import Vue from 'vue'
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import SessionStorage from '@/services/session-storage'

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    logout () {
      if(SessionStorage.get('perfil') === 'A'){
        this.$router.push('/login')
      }else{
        Vue.http.get('api/auth/govbr/logout').then(response => {
          sessionStorage.clear()
          this.$router.push('/login')
          location.href = response.body.data.url
          
        }).catch(e => {})
      }
      
      sessionStorage.clear()
    },
    meuPerfil () {
      this.$router.push('/perfil')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/containers/DefaultHeaderDropdownAccnt.vue